export function getPortalLogo(fallback) {
  try {
    const logo = JSON.parse(localStorage.getItem('portalData'))?.portal_logo;
    if (typeof logo === 'string' && logo.trim()) {
      return logo.trim().replace(/\.svg\+xml$/, '.svg');
    }
  } catch (_) {
    // Unavailable storage or malformed portal data must not interrupt a test.
  }
  return fallback;
}
